import React from 'react';
import styles from './components.module.scss';

export default function Comment({ label }) {
  return <label className={styles.hintLabel}>{label}</label>;
}
